module.exports = __webpack_public_path__ + "static/media/alarm.507f8ea5.svg";